import Axios from "axios";
export const axios = Axios.create();
export const setBaseUrl = (url) => {
    axios.defaults.baseURL = url;
};
export const client = (config, options) => {
    const source = Axios.CancelToken.source();
    return axios({
        ...config,
        ...options,
        cancelToken: source.token,
    });
};
